import GetIssuuDocumentsRequestModelBase from '../_generated/modelBases/get-issuu-documents-request-model-base';

export default class GetIssuuDocumentsRequestModel extends GetIssuuDocumentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
